var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    id: "svg365",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs369"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 3.6374585,10.431411 0.1946823,6.5222198 C 0.07460773,6.3841817 0.00929157,6.2134002 0.00929157,6.0374774 0.00929158,5.8615546 0.07460773,5.6907732 0.1946823,5.552735 L 3.6374585,1.6435537 C 3.7854697,1.5011126 3.9869492,1.4143296 4.2020233,1.4003738 c 0.2150836,-0.013957 0.4280936,0.045929 0.5968954,0.1678093 0.1687925,0.1218775 0.2810769,0.2968715 0.3146364,0.4903575 0.03356,0.193486 -0.014054,0.3913628 -0.1334127,0.5544885 L 2.6562649,5.255643 h 8.4829121 c 0.228265,0 0.447148,0.082365 0.608614,0.2289877 0.161371,0.1466228 0.252095,0.3454941 0.252095,0.5528467 0,0.2073527 -0.09073,0.4062241 -0.252095,0.5528467 -0.161466,0.1466227 -0.380349,0.2289877 -0.608614,0.2289877 H 2.6562649 l 2.3238775,2.6426139 c 0.081802,0.078725 0.1447275,0.1720387 0.1847607,0.2740028 0.040043,0.1019739 0.05633,0.2103929 0.047839,0.3184175 -0.00849,0.107987 -0.041582,0.21316 -0.09717,0.308952 -0.055589,0.0957 -0.1324746,0.179947 -0.2257697,0.24731 -0.093305,0.06737 -0.2009823,0.116431 -0.3162314,0.144014 -0.115249,0.02759 -0.235555,0.03312 -0.3532811,0.01632 C 4.1025547,10.754052 3.9899606,10.715212 3.889629,10.656762 3.7893067,10.598312 3.7034328,10.521567 3.6374583,10.431406 Z",
    fill: "#283856",
    id: "path363",
    style: {
      strokeWidth: 0.938206
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/Left.a6271cbc39cc0e5503243b09075f79ca.svg";
export { ForwardRef as ReactComponent };